<template>
  <div id="nav">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
              {{ currentUserName }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <br />
              <v-img src="../../assets/background/Kings_international_3308.jpg" height="130px" contain></v-img>
            <br />
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link :to="item.path"
          :color="item.color"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-if="settings.length > 0">
              <template v-slot:activator>
                  <v-list-item-icon>
                      <v-icon color="#80CBC4">mdi-cog</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title>Settings</v-list-item-title>
                  </v-list-item-content>
              </template>
              <v-list-item v-for="(item, i) in settings" :key="i" :to="item.path" color="#80CBC4">
                  <v-list-item-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
          </v-list-group>
      </v-list>
  </div>
</template>

<script>
import auth from "../../js/auth"

export default {
    name: "navigation",
    data() {
        return {
          host: location.hostname.toString(),
          currentUserName: "Hello!",
          items: [
            { 
              title: "Home", 
              icon: "mdi-home-outline", 
              path: "/admin/home",
              color: "#2E7D32"
            },
            { 
              title: "Postings Browser", 
              icon: "mdi-note-search-outline", 
              path: "/admin/postingsbrowser",
              color: "#33675E"
            },
            { 
              title: "Postings Manager", 
              icon: "mdi-post-outline", 
              path: "/admin/managepostings",
              color: "#5885AF"
            }
          ],
          settings: [],
          right: null
        };
    },
    methods: {
      checkPermissions(){
        const that = this;
        let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?';
        that.items = [
          { 
            title: "Home", 
            icon: "mdi-home-outline", 
            path: "/admin/home",
            color: "#2E7D32"
          },
          { 
            title: "Postings Browser", 
            icon: "mdi-note-search-outline", 
            path: "/admin/postingsbrowser",
            color: "#33675E"
          },
          { 
            title: "Postings Manager", 
            icon: "mdi-post-outline", 
            path: "/admin/managepostings",
            color: "#5885AF"
          }
        ];
        that.settings = [];
        fetch(api)
          .then(function (response) {
            // Return json response
            return response.json();
          })
          .then(function (json) {
            if (json.result.match(/^OK/i)) {

              that.currentUserName = json.commonname;
              //Navigations

              //Applications
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("allowedDepartments")){
                  if(json.permissions.data[0].allowedDepartments.length > 0){
                    that.insertAt(that.items, 1, {title: "Applications",  icon: "mdi-list-status",  path: "/admin/applications", color: "#7CB342"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.insertAt(that.items, 1, {title: "Applications",  icon: "mdi-list-status",  path: "/admin/applications", color: "#7CB342"});
              }

              //Account Manager
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("getaccountslist")){
                  if(json.permissions.data[0].getaccountslist == 1){
                    that.items.push({title: "Account Manager", icon: "mdi-account-circle-outline", path: "/admin/manageaccounts", color: "#FFCC80"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.items.push({title: "Account Manager", icon: "mdi-account-circle-outline", path: "/admin/manageaccounts", color: "#FFCC80"});
              }

              //Academic Department
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("getacademicdepartments")){
                  if(json.permissions.data[0].getacademicdepartments == 1){
                    that.items.push({title: "Academic Department", icon: "mdi-bank-outline", path: "/admin/managedepartment", color: "#CE93D8"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.items.push({title: "Academic Department", icon: "mdi-bank-outline", path: "/admin/managedepartment", color: "#CE93D8"});
              }

              //Permissions/Users
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("adminpermissionsmanage")){
                  if(json.permissions.data[0].adminpermissionsmanage == 1){
                    that.items.push({title: "Permissions/Users", icon: "mdi-lock-check-outline", path: "/admin/setpermissions", color: "#98B38F"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.items.push({title: "Permissions/Users", icon: "mdi-lock-check-outline", path: "/admin/setpermissions", color: "#98B38F"});
              }

              //Export
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("exportdata")){
                  if(json.permissions.data[0].exportdata == 1){
                    that.items.push({title: "Export", icon: "mdi-chart-box-outline", path: "/admin/export", color: "#D4C88D"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.items.push({title: "Export", icon: "mdi-chart-box-outline", path: "/admin/export", color: "#D4C88D"});
              }

              //Report
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("allowedDepartments")){
                  if(json.permissions.data[0].allowedDepartments.length > 0){
                    that.items.push({title: "Report", icon: "mdi-file-download-outline", path: "/admin/report", color: "#D8A7B1"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.items.push({title: "Report", icon: "mdi-file-download-outline", path: "/admin/report", color: "#D8A7B1"});
              }

              //ITS only
              if(auth.is_ITS()){
                that.items.push({
                    title: "ITS", 
                    icon: "mdi-developer-board", 
                    path: "/admin/itsonly",
                    color: "#977EBE"
                })
              }

              //Settings
              //Announcement
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("setannouncement")){
                  if(json.permissions.data[0].setannouncement == 1){
                    that.settings.push({title: "Announcement", path: "/admin/announcement"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.settings.push({title: "Announcement", path: "/admin/announcement"});
              }

              //Timetable
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("timetableinterface")){
                  if(json.permissions.data[0].timetableinterface == 1){
                    that.settings.push({ title: "Timetable", path: "/admin/timetablemanagement"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.settings.push({ title: "Timetable", path: "/admin/timetablemanagement"});
              }

              //Form Controls
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("adminformcontrol")){
                  if(json.permissions.data[0].adminformcontrol == 1){
                    that.settings.push({ title: "Form Control", path: "/admin/formcontrol"});
                    //that.settings.push({ title: "Posting Control", path: "/postingcontrol"});
                    //that.settings.push({ title: "CUPE Representative", path: "/setcuperep"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.settings.push({ title: "Form Control", path: "/admin/formcontrol"});
                //that.settings.push({ title: "Posting Control", path: "/postingcontrol"});
                //that.settings.push({ title: "CUPE Representative", path: "/setcuperep"});
              }

              //Email Receipt
              if(json.permissions.hasOwnProperty("data")){
                if(json.permissions.data[0].hasOwnProperty("setemail")){
                  if(json.permissions.data[0].setemail == 1){
                    that.settings.push({ title: "Email Receipt", path: "/admin/editemailcontent"});
                  }
                }
              }else if(json.permissions.hasOwnProperty("rootgroup")){
                that.settings.push({ title: "Email Receipt", path: "/admin/editemailcontent"});
              }
            }
          })
          .catch(function () {

          })
      },
      insertAt(array, index, elementsArray) {
        array.splice(index, 0, elementsArray);
      }
    },
    created(){
      const that = this;
      that.checkPermissions();
    }
}
</script>